import { z } from 'zod';
import { useIsAccountingCategorySetupRequired } from '../../queries/useIsAccountingCategorySetupRequired';

export const useAccountingSchema = () => {
    const isAccountingCategorySetupRequired = useIsAccountingCategorySetupRequired();
    return z.object({
        accountingCategoryId: isAccountingCategorySetupRequired ? z.string() : z.string().nullish(),
        rebateAccountingCategoryId: isAccountingCategorySetupRequired ? z.string() : z.string().nullish(),
        canceledItemAccountingCategoryId: z.string().nullish(),
    });
};

export const allowanceAccountingSchema = z.object({
    chargeAccountingCategoryId: z.string(),
    profitAccountingCategoryId: z.string(),
});
